/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Faq_TitleInputs */

const en_directory_ai_tools_faq_title = /** @type {(inputs: Directory_Ai_Tools_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions people ask`)
};

const zh_directory_ai_tools_faq_title = /** @type {(inputs: Directory_Ai_Tools_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大家常问的问题`)
};

/**
* | output |
* | --- |
* | "Questions people ask" |
*
* @param {Directory_Ai_Tools_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_faq_title = /** @type {((inputs?: Directory_Ai_Tools_Faq_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Faq_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_faq_title(inputs)
	return zh_directory_ai_tools_faq_title(inputs)
});
export { directory_ai_tools_faq_title as "directory.ai_tools.faq_title" }